import { Routes, RouterModule } from '@angular/router';
import { NgModule, Component } from '@angular/core';

import { DispatucherRestaurantComponent } from './dispatucher-restaurant/dispatucher-restaurant.component';
import { AddRestaurantComponent } from './add-restaurant/add-restaurant.component';
import { RestaurentsInfoComponent } from './restaurents-info/restaurents-info.component';
import { UpdateRestaurantComponent } from './update-restaurant/update-restaurant.component';
import { AboutComponent } from './restaurents-info/about/about.component';
import { SettingComponent } from './restaurents-info/setting/setting.component';
import { PhotosComponent } from './restaurents-info/photos/photos.component';
import { MenuComponent } from './restaurents-info/menu/menu.component';
import { OrdersComponent } from './restaurents-info/orders/orders.component';

 const routes: Routes = [

  { path: '',      component: DispatucherRestaurantComponent },
  { path: ` ''/:page`,      component: DispatucherRestaurantComponent },
  { path: 'add-restaurant',      component: AddRestaurantComponent },
  { path: 'restaurantsinfo',      component: RestaurentsInfoComponent },
  { path: 'restaurantsinfo/:id',      component: RestaurentsInfoComponent },
  { path: 'restaurantsinfo/:Id', component: RestaurentsInfoComponent,
  children: [
    {path: 'about', component: AboutComponent},
    {path: 'setting', component: SettingComponent},
    {path: 'photos', component: PhotosComponent},
    {path: 'menu', component: MenuComponent},
    {path: 'order', component: OrdersComponent},
  ]},
  {
    path: 'update-restaurant',
    component: UpdateRestaurantComponent
  },
  {
    path: 'update-restaurant/:id',
    component: UpdateRestaurantComponent
  },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
  })
  export class RestaurantRoutingModule { }
